<store-finder [showOnlyStores]="true"
              [showStoresWithProductOrRangeAvailable]="true"></store-finder>